import { api } from '@api/api';
import { Option } from '@api/types/option';

const themeApi = api.injectEndpoints({
  endpoints: (build) => ({
    getThemeOptions: build.query<Option[], number>({
      query: (caseId: number) => ({
        url: 'theme/options',
        method: 'GET',
        params: {
          caseId,
        },
      }),
    }),
  }),
});

export const { useGetThemeOptionsQuery } = themeApi;
